import { ACTION_SET_CONTRACT } from "./names.js";

/**
 * @param {Object} contract
 */
function changeContractInfo(contract) {
  return {
    type: ACTION_SET_CONTRACT,
    payload: contract,
  };
}

export default {
  changeContractInfo,
};
